if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
        this.stickyButton = this.querySelector('.sticky-atc__button');
        this.buttonText = this.querySelector('.sticky-atc__button-text');
        this.priceEl = this.querySelector('.sticky-atc__price .price__regular .price-item--regular');
      }

      connectedCallback() {
        this.originalButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        if (!this.originalButton) return;

        this.observeOriginalButton();
        this.bindStickyButton();
        this.subscribeToVariantChange();
      }

      observeOriginalButton() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        this.observer.observe(this.originalButton);
      }

      bindStickyButton() {
        this.stickyButton.addEventListener('click', () => {
          if (this.stickyButton.disabled) return;
          this.originalButton.click();
        });
      }

      subscribeToVariantChange() {
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data.variant;
          if (!variant) return;

          if (this.priceEl) {
            this.priceEl.textContent = Shopify.formatMoney(variant.price);
          }

          if (variant.available) {
            this.stickyButton.disabled = false;
            if (this.buttonText) this.buttonText.textContent = this.stickyButton.dataset.addToCart;
          } else {
            this.stickyButton.disabled = true;
            if (this.buttonText) this.buttonText.textContent = this.stickyButton.dataset.soldOut;
          }
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
